/**
 * HomeSLDemoStockPageContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLDemoStockPageContent
 */

import { useHomeSLDemoStockPageContentLogic } from '@/hooks/traits/useHomeSLDemoStockPageContentLogic';
import type { HomeSLDemoStockPageContentConfig } from '@/hooks/traits/useHomeSLDemoStockPageContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoStockItem } from '@app/shared';
import { Typography } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { HomeSLDemoStockPageListView } from '@/components/traits/HomeSLDemoStockPageListView';
import { HomeSLDemoStockPageUnitsChartView } from '@/components/traits/HomeSLDemoStockPageUnitsChartView';
import { HomeSLDemoStockPageStatsView } from '@/components/traits/HomeSLDemoStockPageStatsView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeSLDemoStockPageContentViewProps {
  config?: Partial<HomeSLDemoStockPageContentConfig>;
}

export function HomeSLDemoStockPageContentView({ config: propsConfig }: HomeSLDemoStockPageContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLDemoStockPageContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoStockItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLDemoStockPageContent">
      {slotWriter['main'] === 'INIT' ? (<Stack gap="md" className="p-3" direction="vertical"><Stack gap="none" direction="vertical"><Typography variant="h3" content={renderPatternValue(__t("std-almadar-demo-stock-page:page.title"))} /><Typography color="muted" content={renderPatternValue(__t("std-almadar-demo-stock-page:page.subtitle"))} variant="small" /></Stack><HomeSLDemoStockPageStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeSLDemoStockPageUnitsChartView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeSLDemoStockPageListView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLDemoStockPageContentView;
